import React from 'react';
import Button from 'rmwc/Button';
import { TextField } from 'rmwc/TextField';
import { saveUserCapturedEvent, authUserUId } from "../api/FirebaseAPI";
import { Redirect } from "react-router-dom";
import "./CaptureEventPage.css"
import { withRouter } from 'react-router-dom';

class CaptureEventPage extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      event: {
        title:"",
        facebookUrl:"",
        ticketUrl:"",
        hostedBy:"",
        email:"",
        startDate:"",
        published:false
      },
      disableButton:true
    }
    this.handleClick = this.handleClick.bind(this);
    this.handleDataChange = this.handleDataChange.bind(this);
  }

  componentDidMount() {

  }

  handleDataChange(e) {
    const target = e.target;
    const id = target.id;
    const value = target.value;
    this.setState({event:Object.assign(this.state.event, {[id]: value})}, () => {
      this.validate()
    });
  }

  validate() {
    if (this.state.event.title.length < 5) {
      this.setState({disableButton:true})
      return;
    }
    if ((this.state.event.facebookUrl.length < 5) && (this.state.event.ticketUrl.length < 5)) {
      this.setState({disableButton:true})
      return;
    }
    if (this.state.event.email.length < 5) {
      this.setState({disableButton:true})
      return;
    }
    this.setState({disableButton:false})
  }


  async handleClick() {
    var result = await saveUserCapturedEvent(this.state.event);
    console.log(result);
    if (result === "SUMMITTED") {
      alert("Thanks you! Your event is pending a review.");
      console.log(this.state);
      this.props.history.push('/')
    } else if (result === "NOT_AUTHENTICATED") {
      alert("Please sign-in in order to sumbit your event")
    } else {
      alert("Unable to submitted event, please try again.");
    }
  }

  render() {
    return (
      <div className="capture-event">
        <div>
          <h2>Capture Event</h2>
        </div>
        <div>
          All event information and images will be sourced from the 'Ticket/Bookings Link' or 'Facebook Link' supplied below.
        </div>
        <div>
          <TextField
            fullwidth
            required
            id="title"
            label="Title"
            value={this.state.event.title}
            onChange={this.handleDataChange}
          />
        </div>
        <div>
          <TextField
            fullwidth
            id="facebookUrl"
            label="Facebook Link"
            value={this.state.event.facebookUrl}
            onChange={this.handleDataChange}
          />
        </div>
        <div>
          <TextField
            fullwidth
            required
            id="ticketUrl"
            label="Ticket/Bookings Link"
            value={this.state.event.ticketUrl}
            onChange={this.handleDataChange}
          />
        </div>
        <div>
          <TextField
            fullwidth
            id="hostedBy"
            label="Hosted By"
            value={this.state.event.hostedBy}
            onChange={this.handleDataChange}
          />
        </div>
        <div>
          <TextField
            fullwidth
            required
            id="email"
            label="Your Email"
            value={this.state.event.email}
            onChange={this.handleDataChange}
          />
        </div>
        <br />
        <div>
          <Button
            raised
            disabled={this.state.disableButton}
            onClick={this.handleClick}>Submit Event for Review
          </Button>
        </div>
      </div>
    )
  }
}

export default withRouter(CaptureEventPage)

/*
id = 'facebookUrl'
className = 'facebookUrl'
label="Facebook"
value={this.state.event.facebookUrl}
onChange={this.handleDataChange}
*/



// WEBPACK FOOTER //
// ./src/containers/CaptureEventPage.js